import styled, { css } from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { flexCenter, pxToRem } from 'Styles/utils/utils';

export const UploadComponent = styled.aside`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border: 2px solid ${({ theme: { colors } }) => colors.blue_2};
  background-color: ${({ theme: { colors } }) => colors.blue_6};
  border-radius: ${pxToRem(8)};
  width: 100%;
  min-height: ${pxToRem(50)};
`;

export const AsideContent = styled(FlexContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${pxToRem(350)};
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: ${pxToRem(200)};
  }
`;

export const DropZone = styled.div`
  border: 2px dashed ${({ theme: { colors } }) => colors.blue_2};
  padding: ${pxToRem(10)} 0;
  background-color: ${({ theme: { colors } }) => colors.blue_6};
  min-height: ${pxToRem(50)};
  ${flexCenter};
  flex-direction: column;
  border-radius: ${pxToRem(8)};
  ${({ isDragActive }) =>
    isDragActive &&
    css`
      background: ${({ theme: { colors } }) => colors.green_6};
    `}
`;

export const Errors = styled.ul`
  font-size: ${pxToRem(14)};
  list-style: disc;
  padding: ${pxToRem(10)} ${pxToRem(20)};
  li:not(:last-child) {
    margin-bottom: ${pxToRem(10)};
  }
`;

export const BrowseButton = styled.button`
  font-size: ${pxToRem(12)};
  color: ${({ theme: { colors } }) => colors.green_3};
  cursor: pointer;
  font-weight: bold;
`;

export const TrashButton = styled.button`
  cursor: pointer;
`;
